export default {"src":"/_next/static/media/illustration-dog-bowl-blob.72e80352.svg","height":505,"width":312};